import React, { Component, Fragment } from "react";
import ModalTooLongContent from "../../../shared/ModalTooLongContent/ModalTooLongContent";
import ModalTooLongContentTitle from "../../../shared/ModalTooLongContent/ModalTooLongContentTitle";
import Select from "../../../shared/Select/Select";
import Textarea from "../../../shared/Textarea/Textarea";
import Button from "../../../shared/button/button";
import Loading from "../../../shared/Loading/Loading";

const options = [
	{
		value: "1",
		label: "Milhas não reembolsadas após cancelamento"
	},
	{
		value: "2",
		label: "Passagem debitada em duplicidade"
	},
	{
		value: "3",
		label: "Problema de pagamento"
	},
	{
		value: "4",
		label: "Quantidade de milhas utilizadas errada"
	},
	{
		value: "5",
		label: "Revenda"
	},
	{
		value: "6",
		label: "Taxa de embarque e/ou bagagem"
	},
	{
		value: "7",
		label: "Utilização de mais milhas do que foi ofertado"
	}
];

class SaleDetailsInconsistencyModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			text: null
		};
	}
	close = () => {
		this.props.close(false);
	};

	confirm = () => {
		let { errorDivergence } = this.state;
		if (!this.state.text) {
			errorDivergence = "Campo obrigatório.";
			this.setState({ errorDivergence });
		} else {
			this.props.confirm(this.state.text);
		}
	};
	onChangeText = e => {
		this.setState({
			text: e.target.value,
			errorDivergence: undefined
		});
	};

	render() {
		return (
			<div className="sale-details-inconsistency-modal">
				<ModalTooLongContent>
					<div className="sale-details-inconsistency-modal__panel">
						<div>
							<ModalTooLongContentTitle close={this.close} title="Informar divergência" />
						</div>
						<div className="sale-details-inconsistency-modal__content">
							<h4 className="sale-details-inconsistency-modal__h4">O que está acontecendo?</h4>
							<p>Conte pra gente os detalhes sobre a divergência que você teve nesta venda.</p>
							<Textarea errorMessage={this.state.errorDivergence} onChange={this.onChangeText} />
							<p>
								Este campo é exclusivo para informações sobre esta venda. Caso tenha outras
								divergências, entre em contato pelo e-mail{" "}
								<a
									href="mailto:contato@maxmilhas.com.br"
									data-action="sale-details-inconsistency-modal-mail"
								>
									contato@maxmilhas.com.br
								</a>{" "}
								ou ligue para nossa equipe de atendimento.
							</p>
						</div>
						<div className="sale-details-inconsistency-modal__button">
							<Button
								className="btn-primary-md"
								onClick={this.confirm}
								data-action="sale-details-incistency-modal-send"
							>
								<span className="font-weight-light font-size-normal">Enviar</span>
							</Button>
						</div>
						{this.props.loading ? (
							<Loading className="sale-details-inconsistency-modal__loading" />
						) : (
							<Fragment />
						)}
					</div>
				</ModalTooLongContent>
			</div>
		);
	}
}

export default SaleDetailsInconsistencyModal;
